import { Injectable, HostListener, OnDestroy } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Subject } from 'rxjs';
import 'rxjs/Rx';

import { AppConfigService } from '../app.config';

@Injectable()
export class FormsService {

    _error$: Subject<any> = <Subject<any>>new Subject();
    _collection$: Subject<any[]> = <Subject<any[]>>new Subject();

    get collection$() { return this._collection$.asObservable(); }
    get error$() { return this._error$.asObservable(); }

    constructor(private config: AppConfigService, private http: Http) {}
    getForms(personId: number) {
        const contentHeaders = new Headers();
        contentHeaders.append('Accept', 'application/json');
        contentHeaders.append('Content-Type', 'application/json');
        contentHeaders.append('Authorization', this.config.token);

        this.http.get(`${this.config.url}/person-forms/${personId}`, {headers: contentHeaders}).map( (response:any) => response.json()).subscribe( 
            (data:any[]) => {
                this._collection$.next(data);
            }, 
            (error: any) => {
                console.log(`Could not load forms.`, error);
                this._error$.next(error);
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/forms.ts